const UserTypes = {
    USER : "USER",
    CLIENT : "CLIENT"
}

export default UserTypes;